import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { useMenuItem } from "./useMenuItem.mjs";
const MenuItem = ({
  children,
  onClick,
  data,
  tone,
  weight,
  badge,
  icon,
  id,
  disabled
}) => {
  const { menuItemProps, MenuItemChildren } = useMenuItem({
    tone,
    onClick,
    data,
    id,
    disabled
  });
  return /* @__PURE__ */ jsx(Box, { ...menuItemProps, component: "button", type: "button", disabled, children: /* @__PURE__ */ jsx(MenuItemChildren, { tone: disabled ? "disabled" : tone, weight, icon, badge, children }) });
};
MenuItem.__isMenuItem__ = true;
export {
  MenuItem
};
